var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedTime } from 'react-intl';
import { MessageType } from '@amityco/js-sdk';
import customizableComponent from '../../../core/hocs/customization';
import { backgroundImage as UserImage } from '../../../icons/User';
import Options from './Options';
import MessageContent from './MessageContent';
import { Avatar, AvatarWrapper, MessageReservedRow, MessageWrapper, MessageContainer, GeneralMessageBody, DeletedMessageBody, UnsupportedMessageBody, UserName, BottomLine, MessageDate, } from './styles';
const MessageBody = (_a) => {
    var { isDeleted, type, isSupportedMessageType } = _a, otherProps = __rest(_a, ["isDeleted", "type", "isSupportedMessageType"]);
    if (isDeleted) {
        return React.createElement(DeletedMessageBody, Object.assign({}, otherProps, { "data-qa-anchor": "message-body-deleted" }));
    }
    if (!isSupportedMessageType) {
        return React.createElement(UnsupportedMessageBody, Object.assign({}, otherProps, { "data-qa-anchor": "message-body-unsupported" }));
    }
    return React.createElement(GeneralMessageBody, Object.assign({}, otherProps, { "data-qa-anchor": "message-body-general" }));
};
const Message = ({ messageId, avatar, type, data, createdAt, isDeleted, isIncoming, isConsequent, userDisplayName, containerRef, }) => {
    const shouldShowUserName = isIncoming && !isConsequent && userDisplayName;
    const isSupportedMessageType = [MessageType.Text, MessageType.Custom].includes(type);
    const getAvatarProps = () => {
        if (avatar)
            return { avatar };
        return { backgroundImage: UserImage };
    };
    return (React.createElement(MessageReservedRow, { isIncoming: isIncoming },
        React.createElement(MessageWrapper, null,
            isIncoming && (React.createElement(AvatarWrapper, null, !isConsequent && React.createElement(Avatar, Object.assign({}, getAvatarProps())))),
            React.createElement(MessageContainer, { "data-qa-anchor": "message" },
                shouldShowUserName && React.createElement(UserName, null, userDisplayName),
                React.createElement(MessageBody, { type: type, isIncoming: isIncoming, isDeleted: isDeleted, isSupportedMessageType: isSupportedMessageType },
                    React.createElement(MessageContent, { data: data, type: type, isDeleted: isDeleted }),
                    !isDeleted && (React.createElement(BottomLine, null,
                        React.createElement(MessageDate, null,
                            React.createElement(FormattedTime, { value: createdAt })),
                        React.createElement(Options, { messageId: messageId, data: data, isIncoming: isIncoming, isSupportedMessageType: isSupportedMessageType, popupContainerRef: containerRef }))))))));
};
Message.propTypes = {
    messageId: PropTypes.string.isRequired,
    type: PropTypes.oneOf(Object.values(MessageType)).isRequired,
    data: PropTypes.object.isRequired,
    createdAt: PropTypes.instanceOf(Date),
    userDisplayName: PropTypes.string,
    isDeleted: PropTypes.bool,
    isIncoming: PropTypes.bool,
    isConsequent: PropTypes.bool,
    avatar: PropTypes.string,
    containerRef: PropTypes.object.isRequired,
};
Message.defaultProps = {
    userDisplayName: '',
    avatar: '',
    isDeleted: false,
    isIncoming: false,
    isConsequent: false,
};
export default customizableComponent('Message', Message);
//# sourceMappingURL=index.js.map